import { Link, useLocation } from 'react-router'

import { BUSINESS_ACCOUNTS_PATH, isBusinessAccountsPath } from '@/lib/business-app-path'
import { cn } from '@/lib/utils'

const PERSONAL_ACCOUNTS_PATH = '/accounts'

type CatalogNavItemProps = {
  label: string
  to: string
  active: boolean
}

function CatalogNavItem({ label, to, active }: CatalogNavItemProps) {
  if (active) {
    return (
      <span
        aria-current="page"
        className="font-bold text-gray-700"
      >
        {label}
      </span>
    )
  }

  return (
    <Link
      to={to}
      className={cn(
        'font-normal text-gray-400 transition-colors duration-150',
        'hover:text-brand',
      )}
    >
      {label}
    </Link>
  )
}

export function AccountsCatalogNav() {
  const { pathname, search } = useLocation()
  const onPersonalAccounts = pathname === PERSONAL_ACCOUNTS_PATH
  const onBusinessAccounts = isBusinessAccountsPath(pathname)

  return (
    <div className="flex items-center gap-4">
      <CatalogNavItem
        label="Personal Accounts"
        to={`${PERSONAL_ACCOUNTS_PATH}${search}`}
        active={onPersonalAccounts}
      />
      <CatalogNavItem
        label="Business Accounts"
        to={`${BUSINESS_ACCOUNTS_PATH}${search}`}
        active={onBusinessAccounts}
      />
    </div>
  )
}
